(function () {
  'use strict';
  if (window.BafDelivery) return;

  // Keep every calendar-day estimate on one store-wide time basis.
  // Saved line-item dates are order metadata, not a current delivery estimate.
  var defaultLeadDays = 10;
  var storeDay = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Prague', year: 'numeric', month: 'numeric', day: 'numeric'
  });
  var displayDate = new Intl.DateTimeFormat('en-US', {
    timeZone: 'UTC', month: 'short', day: 'numeric'
  });
  var selector = '#mp-delivery, [data-baf-delivery-date], [data-cart-delivery-date], .product-availability__delivery-date';
  var refreshPending = false;

  function getDate(displayFormat, now, leadDays) {
    // Only the current cart summary opts into the Art Prints estimate.
    // Portrait and Wear callers retain the ten-day default.
    leadDays = Number(leadDays) === 7 ? 7 : defaultLeadDays;
    var parts = {};
    storeDay.formatToParts(now || new Date()).forEach(function (part) {
      parts[part.type] = part.value;
    });
    // Add calendar days in UTC so daylight-saving changes cannot shift the day.
    var date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + leadDays));
    if (displayFormat) return displayDate.format(date);
    return String(date.getUTCDate()).padStart(2, '0') + '/' +
      String(date.getUTCMonth() + 1).padStart(2, '0') + '/' + date.getUTCFullYear();
  }

  function refresh() {
    var dates = {};
    document.querySelectorAll(selector).forEach(function (element) {
      var leadDays = Number(element.getAttribute('data-baf-delivery-days')) === 7 ? 7 : defaultLeadDays;
      var date = dates[leadDays] || (dates[leadDays] = getDate(true, undefined, leadDays));
      var text = element.hasAttribute('data-cart-delivery-date') ? 'Delivery by: ' + date : date;
      if (element.textContent !== text) element.textContent = text;
    });
  }

  function scheduleRefresh() {
    if (refreshPending) return;
    refreshPending = true;
    window.requestAnimationFrame(function () {
      refreshPending = false;
      refresh();
    });
  }

  function refreshVisible() {
    if (document.visibilityState === 'visible') refresh();
  }

  function init() {
    refresh();
    // Covers newly rendered drawers, quick views and theme editor sections.
    new MutationObserver(function (records) {
      var hasDeliveryNode = records.some(function (record) {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target && target.matches(selector)) return true;
        if (record.type !== 'childList') return false;
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
        });
      });
      if (hasDeliveryNode) scheduleRefresh();
    }).observe(document.body, { childList: true, characterData: true, attributes: true, attributeFilter: ['data-baf-delivery-days'], subtree: true });
  }

  window.BafDelivery = { getDate: getDate, refresh: refresh };
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', refreshVisible);
  document.addEventListener('cart:update', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);
  // The theme's dialog:open event does not bubble.
  document.addEventListener('dialog:open', scheduleRefresh, true);
  window.setInterval(refreshVisible, 60000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
